module.exports = __webpack_public_path__ + "static/media/img-reel-footer.c000f508.png";